import { render, staticRenderFns } from "./PortfolioOverview.vue?vue&type=template&id=2c4bd6fa&scoped=true&"
import script from "./PortfolioOverview.vue?vue&type=script&lang=js&"
export * from "./PortfolioOverview.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioOverview.vue?vue&type=style&index=0&id=2c4bd6fa&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4bd6fa",
  null
  
)

export default component.exports